import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';

export default class FiltroModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filtro: props.filtro,
        }
    }

    async setFiltro(filtro) {
        await this.props.salvar(filtro);
    }

    render() {
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <div className="header">
                    {/* <img alt="" className="emoji" src={Dollar} /> */}
                    <h1>Ordenar resultado por</h1>
                </div>

                <div className="options">
                        <div onClick={() => {this.state.filtro === 1 ? this.setFiltro(0) : this.setFiltro(1)}}
                            className={this.state.filtro === 1 ? 'option-selected' : 'option'}>
                            <span>Bairros que você entrega</span>
                        </div>
                        <div onClick={() => {this.state.filtro === 2 ? this.setFiltro(0) : this.setFiltro(2)}}
                            className={this.state.filtro === 2 ? 'option-selected' : 'option'}>
                            <span>Bairros que você não entrega</span>
                        </div>
                        <div onClick={() => {this.state.filtro === 3 ? this.setFiltro(0) : this.setFiltro(3)}}
                            className={this.state.filtro === 3 ? 'option-selected' : 'option'}>
                            <span>Taxas mais altas</span>
                        </div>
                        <div onClick={() => {this.state.filtro === 4 ? this.setFiltro(0) : this.setFiltro(4)}}
                            className={this.state.filtro === 4 ? 'option-selected' : 'option'}>
                            <span>Taxas menores</span>
                        </div>
                    </div>
            </Container>
        )
    }
}